import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectUserSubscriptionInfo } from 'root-redux/selects/user'

import {
  IUserExtraSubscription,
  IUserSubscriptionsInfo,
} from 'models/commonApi.model'

import { SubscriptionContainer as Container } from 'common-styles'

import { StyledSubscriptions as S } from '../../Subscriptions.styles'

type TWithdrawnSubscriptionDetailsProps = {
  extra?: IUserExtraSubscription
  secondarySubscription?: IUserSubscriptionsInfo
}

export const WithdrawnSubscriptionDetails: React.FC<
  TWithdrawnSubscriptionDetailsProps
> = ({ extra, secondarySubscription }: TWithdrawnSubscriptionDetailsProps) => {
  const { t } = useTranslation()
  const subscriptionInfo = useSelector(selectUserSubscriptionInfo)
  const userSubscriptionInfo = secondarySubscription || subscriptionInfo

  const withdrawalDate = extra?.canceledAt || userSubscriptionInfo?.canceledAt

  return (
    userSubscriptionInfo && (
      <>
        <S.Separator />
        {withdrawalDate && (
          <S.SubscriptionRow>
            <span>{t('withdrawal.canceled.withdrawalDate')}</span>
            <Container.InfoValue>{withdrawalDate}</Container.InfoValue>
          </S.SubscriptionRow>
        )}
        <S.SubscriptionRow>
          <span>{t('withdrawal.canceled.accessValidUntil')}</span>
          <Container.InfoValue>
            {extra?.canceledAt || userSubscriptionInfo.endDate}
          </Container.InfoValue>
        </S.SubscriptionRow>
        <S.Separator />
        <S.WithdrawalDisclaimer>
          {t('withdrawal.canceled.noCharge')}
        </S.WithdrawalDisclaimer>
        <S.WithdrawalDisclaimer>
          {t('withdrawal.canceled.refund')}
        </S.WithdrawalDisclaimer>
      </>
    )
  )
}
